import { render, staticRenderFns } from "./Carrito.vue?vue&type=template&id=7c049ac6&scoped=true"
import script from "./Carrito.vue?vue&type=script&lang=js"
export * from "./Carrito.vue?vue&type=script&lang=js"
import style0 from "./Carrito.vue?vue&type=style&index=0&id=7c049ac6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c049ac6",
  null
  
)

export default component.exports